import { ITableRow, IUpdateTableViewCell } from 'types'
import {
  ISpreadsheetData,
  ITableRowInGroup,
  IGroupRowCreate,
  IGroupCollapsed,
  ITreeGroupRow
} from 'components/spreadsheet/types'
import { ViewAdapterResult } from './types'
import { hasSyncStartedThisSession } from 'components/spreadsheet/helpers/syncSession'

export function createSpreadsheetAdapter(spreadsheetData: ISpreadsheetData): ViewAdapterResult {
  return {
    effectiveRows: spreadsheetData.rows,
    effectiveTotalRows: spreadsheetData.totalRows,
    effectiveColumnIdToIndex: spreadsheetData.columnIdToIndex,
    effectiveIndexToColumnId: spreadsheetData.indexToColumnId,
    effectiveColumns: spreadsheetData.viewDetails.columns,

    rowsViewportOverrides: {
      groupBy: spreadsheetData.userConfiguration.groupSettings,
      // Keep this in step with `showAddRow` in the rows component: whenever the add-row is
      // hidden we must also drop its reserved height, otherwise the grid leaves a blank row.
      disableNewRow:
        spreadsheetData.viewDetails.disableNewRow ||
        spreadsheetData.tableDetails.isSynced ||
        spreadsheetData.tableDetails.isSyncing ||
        hasSyncStartedThisSession(spreadsheetData.tableDetails.publicId),
      unpackMultiselectGroupView: spreadsheetData.viewDetails.unpackMultiselectGroupView,
      treeGroupView: spreadsheetData.viewDetails.treeGroupView,
      columnStore: spreadsheetData.columnStore,
      visibleBitmap: spreadsheetData.visibleBitmap,
      visibleCount: spreadsheetData.visibleCount
    },

    columnsViewportOverrides: {
      frozenIndex: spreadsheetData.viewDetails.frozenIndex,
      rawGroupByColumns: spreadsheetData.userConfiguration.groupSettings,
      hiddenColumnIds: spreadsheetData.userConfiguration.hiddenColumns,
      treeGroupView: spreadsheetData.viewDetails.treeGroupView
    },

    effectiveSpreadsheetData: spreadsheetData,

    mapCellsForWrite: (cells: IUpdateTableViewCell) => cells,

    transformPastedCells: () => {},

    columnStoreForCopy: spreadsheetData.columnStore,

    getRenderedRows: (
      expandedRowsWithGroups: (ITableRow | ITableRowInGroup | IGroupRowCreate | IGroupCollapsed | ITreeGroupRow)[],
      sd: ISpreadsheetData
    ) => {
      if (sd.userConfiguration.groupSettings.length > 0) return expandedRowsWithGroups
      const bitmap = sd.visibleBitmap
      if (bitmap) {
        const visible: ITableRow[] = []
        for (let i = 0; i < sd.rows.length; i++) {
          if (bitmap[i]) visible.push(sd.rows[i])
        }
        return visible
      }
      return sd.rows
    },

    rowsForSelectionCheck: spreadsheetData.rows,
    bitmapForSelectionCheck: spreadsheetData.visibleBitmap,

    coordinateMap: null
  }
}
